// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum ANNOTATION_TARGET_SCOPE {
    post = 'post',
    chapter = 'chapter',
    section = 'section',
    annotation = 'annotation',
}
